import { UnitOptionUsePoint } from './UnitOptionUsePoint';
import { UnitOptionAvailabilityActivator } from './UnitOptionAvailabilityActivator';

export interface UnitOptionAvailability {
  id: number;
  modifierId: number;
  activator: UnitOptionAvailabilityActivator;
  action: UnitOptionAvailabilityAction;
  armyOrganisationId: number | null;
  unitId: number | null;
  unitOptionId: number | null;
  sizeMin: number | null;
  usePoints: UnitOptionUsePoint | null;
  value: number | null;
}

export enum UnitOptionAvailabilityAction {
  Enable = 0,
  Disable = 1,
  AutoSelect = 2,
  ChangePoints = 3,
  ChangeChoiseLimit = 4,
}
